import React, { useState, useEffect } from 'react';
import {
  Alert,
  Button, CircularProgress, Container, FormHelperText, Grid, Snackbar, TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { forgotPassword } from '../../../../Redux/Models/auth';

export default function ForgotPassword({
  isLoading,
  error,
  message,
  resetLinkSent,
  classes,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    dispatch(forgotPassword(email));
  };

  useEffect(() => {
    if (submitted && resetLinkSent) {
      // setSnackbar({
      //   open: true,
      //   message: 'Reset password link has sent. Please check your email!',
      //   severity: 'success',
      // });
      navigate(ROUTES.resetPassConfirmation(), { state: { email } });
    }
  }, [submitted, resetLinkSent]);

  const showError = submitted && error && !resetLinkSent;

  return (
    <div className={classes.root}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            {/* <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton> */}
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <h3 className="mt-6 s-16">Forgot password</h3>

              <div className="desc center mt-1 s-14">
                Worry not we send you the instructions!
              </div>
            </div>
            <form onSubmit={handleSubmit} className="mt-6">

              <div className="mt-4">
                <label htmlFor="email">
                  Your email
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  type="email"
                  size="small"
                  error={showError}
                  value={email}
                  onChange={({ target }) => setEmail(target.value)}
                  id="email"
                  required
                  placeholder="youremail@address.com"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    autoComplete: 'new-password',
                  }}
                />
                {showError
                && <FormHelperText error>{message}</FormHelperText>}
              </div>

              <div className="center mt-4">
                <Button disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} size="large" type="submit" variant="contained" className="btn-contained" fullWidth>Reset password</Button>
              </div>
              <div className="center mt-4 align-items-center flex-center flex">
                <ArrowBack fontSize="small" />
                <Link to={ROUTES.signin()} className="s-14 link black weight-600">Back to Sign in</Link>
              </div>

            </form>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
